import { useEffect } from 'react'

import { publishEvent } from '@zet/analytics'
import { Stack, colors } from '@zet/design-system'
import AssignedOutlined from '@zet/design-system/svg/AssignedOutlined'
import MoneyBagOutlined from '@zet/design-system/svg/MoneyBagOutlined'
import CardSVG from '@zet/svg/CardSVG'
import MyCustomerSVG from '@zet/svg/MyCustomerSVG'
import MyLeadsSVG from '@zet/svg/MyLeadsSVG'
import MyTeam from '@zet/svg/MyTeam'
import ReferAndEarnSVG from '@zet/svg/ReferAndEarnSVG'
import VisitingCardSmallSVG from '@zet/svg/VisitingCardSmallSVG'
import CreditScoreCheck from '@zet/svg/creditScoreCheck'
import InterestRateIcon from '@zet/svg/loanBrandCard/interestRate.svg'
import OfferTag from '@zet/svg/offerTag.svg'
import LottieView from 'lottie-react-native'

import OfferLetter from '../assets/svg/offerLetter.svg'
import Training from '../assets/svg/training.svg'
import { i18n } from '../localization'

export const bestOffersFilters = [
  {
    label: i18n.t('bestOffers.category'),
    icon: 'MoreOutlined',
    type: 'category',
  },
  {
    label: i18n.t('bestOffers.customers'),
    icon: 'UserGroupOutlined',
    type: 'customer',
  },
  {
    label: i18n.t('bestOffers.brand'),
    icon: 'TagOutlined',
    type: 'brand',
  },
]

export const BestOffer = () => {
  useEffect(() => {
    publishEvent('screen_view', {
      screen_name: 'best_offers',
    })
  }, [])
  return (
    <Stack className="rounded-md bg-[#F2F7FF]" style={{ height: 48 }}>
      <LottieView
        autoPlay
        className="w-[49] self-center rounded-md"
        source={require('../assets/lottie/bestOffer.json')}
        style={{ height: 48 }}
      />
    </Stack>
  )
}

export const bestOffersFiltersSearch = {
  customer: i18n.t('bestOffers.customerSearch'),
  brand: i18n.t('bestOffers.brandSearch'),
}

export const BEGINNER = 'BEGINNER'
export const PRO = 'PRO'
export const GENIUS = 'GENIUS'
export const EXPERT = 'EXPERT'

export const enum AgentTiers {
  BEGINNER = 'Beginner',
  PRO = 'Pro',
  GENIUS = 'Genius',
  EXPERT = 'Expert',
}

export const zetTopWidgets = {
  myCustomer: {
    cardIcon: <MyCustomerSVG />,
    cardTitle: i18n.t('myCustomers.header'),
    cardTagTop: 'number',
    navigation: 'MyCustomers',
    eventName: 'home_page_my_customers',
  },
  leads: {
    cardIcon: <MyLeadsSVG />,
    cardTitle: i18n.t('botomTab.leads'),
    cardTagTop: 'number',
    navigation: 'Leads',
    eventName: 'home_page_my_leads',
  },
  training: {
    cardIcon: <Training />,
    cardTitle: i18n.t('navigationHeading.training'),
    cardTagTop: 'new',
    navigation: 'PreRecordedTraining',
    eventName: 'home_page_training',
  },
  idCard: {
    cardIcon: <CardSVG />,
    cardTitle: i18n.t('idCard.myIdCard'),
    cardTagTop: 'pending',
    navigation: 'MyIdCard',
    eventName: 'home_page_id_card',
  },
  businessCard: {
    cardIcon: <VisitingCardSmallSVG />,
    cardTitle: i18n.t('myVisitingCard'),
    cardTagTop: null,
    navigation: 'MyVisitingCard',
    eventName: 'home_page_visiting_card',
  },
  offerLetter: {
    cardIcon: <OfferLetter />,
    cardTitle: i18n.t('joiningKit.offerLetter'),
    cardTagTop: null,
    navigation: 'OfferLetter',
    eventName: 'home_page_offer_letter',
  },
  cibilCheck: {
    cardIcon: <CreditScoreCheck />,
    cardTitle: i18n.t('cibil'),
    cardTagTop: null,
    navigation: 'CreditScore',
    eventName: 'home_page_credit_score',
  },
  myTeams: {
    cardIcon: <MyTeam />,
    cardTitle: i18n.t('myTeams.title'),
    cardTagTop: 'number',
    navigation: 'MyTeams',
    eventName: 'home_page_my_teams',
  },
  referAndEarn: {
    cardIcon: <ReferAndEarnSVG />,
    cardTitle: i18n.t('referAndEarn'),
    cardTagTop: 'text',
    navigation: 'Network',
    eventName: 'home_page_refer_and_earn',
  },
  bestOffers: {
    cardIcon: <BestOffer />,
    cardTitle: i18n.t('bestOffersHeading'),
    cardTagTop: 'new',
    navigation: 'BestOffers',
    eventName: 'best_offers_icon',
  },
}

export const bottomSheetZetWidgets = [
  'bestOffers',
  'myCustomer',
  'leads',
  'training',
  'idCard',
  'businessCard',
  'offerLetter',
  'cibilCheck',
  'myTeams',
  'referAndEarn',
]

export const howToEarn = [
  {
    imgUrl:
      'https://onecode-asset.s3.ap-south-1.amazonaws.com/zet/Thumbnails/How+to+earn+on+zet.png',
    videoId: 'kcvKVPUyrEY',
    title: i18n.t('howtoEarn'),
  },
  {
    imgUrl:
      'https://onecode-asset.s3.ap-south-1.amazonaws.com/zet/Thumbnails/How+to+Sell+CC.png',
    videoId: 'bYHggudoVAc',
    title: i18n.t('howToSell'),
  },
]

export const DemoSaleStates = {
  ADD_CUSTOMER: 'ADD_CUSTOMER',
  NON_VERIFIED_CUSTOMER: 'NON_VERIFIED_CUSTOMER',
  VERIFIED_CUSTOMER: 'VERIFIED_CUSTOMER',
  DEMO_LEAD_ADDED: 'DEMO_LEAD_ADDED',
}

export const DEMO_SALE = 'demoSale'

export const getIcon = (type: string | undefined) => {
  switch (type) {
    case 'bag':
      return <MoneyBagOutlined size={17} color={colors.grays[60]} />
    case 'interestRate':
      return <InterestRateIcon />
    case 'user':
      return <AssignedOutlined size={17} color={colors.grays[60]} />
    default:
      return <OfferTag />
  }
}
